export default "__VITE_ASSET__BkMvntNm__"